import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID,CUSTOM_ELEMENTS_SCHEMA, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, XHRBackend, RequestOptions, Http } from '@angular/http';
import { ClarityModule } from 'clarity-angular';
import { AppComponent } from './app.component';
import { ROUTING } from "./app.routing";
import { REPORTSROUTING } from "./reports/reports.routing";
import { ADMINROUTING } from "./admin/admin.routing";
import { REVIEWROUTING } from "./review/review.routing";
import { COMPAREROUTING } from "./compare/compare.routing";
import { HomeComponent } from "./home/home.component";
import { ReportsComponent } from "./reports/reports.component";
import { LoginComponent } from "./login/login.component";
import { LimitsComponent } from "./limits/limits.component";
import { CompareComponent } from "./compare/compare.component";
import { AdminComponent } from './admin/admin.component';
import { AuthComponent } from './auth/auth.component';
import { ReviewComponent } from './review/review.component';
import { ModalComponent } from './common/modal/modal.component';
import { ManageReleaseModalComponent } from './manage-release-modal/manage-release-modal.component';
import { ChatModalComponent } from './common/chatmodal/chatmodal.component';
import { FormModalComponent } from './common/formmodal/formmodal.component';
import { LimitFormModalComponent } from './limits/limitformmodal.component';
import { AlertComponent } from './common/alert/index';
import { AuthUsersComponent } from './authuser/authuser.component';
import { ManageReleasesComponent } from './managereleases/managereleases.component';
import { Globals } from "./common/globals";
import { AlertService, AuthenticationService, ReportsService, LimitsService, AuthService } from "./services/index";
import { AuthGuard } from './common/auth.guard';
import { Logger, Options } from 'angular2-logger/core';
import { FooterComponent } from './footer/footer.component';
import { GuestComponent } from "./guest/guest.component";
//import { CookieService } from 'angular2-cookie/services/cookies.service';
import { SsoRedirectService } from './services/ssoredirect/sso-redirect.service';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { LimitlabelmodalComponent } from './limits/limitlabelmodal.component';
import { PDFGenerator } from "./common/pdf/pdfgenerator";
import { AuthModule } from './auth.module';

import { CategoryModalComponent } from './limits/categorymodal/categorymodal.component';
import { AdminService } from "./admin/admin.service";
import { CookieService } from "ngx-cookie-service";
import { NumberConstants } from "app/common/numberconstants";
import { EnvironmentsService } from "./services/enviornment.service";
import { ApiService } from "./services/api.service";
import { AuthProviderService } from "./services/auth.provider.service";
import { UserService } from "./services/user.service";

import {TranslateLoader, TranslateModule, TranslateCompiler, TranslateService, MissingTranslationHandlerParams, MissingTranslationHandler} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { environment } from "environments/environment.stage";
import { Observable } from "rxjs";
import { TranslateStore } from "@ngx-translate/core/src/translate.store";
import { AddProductComponent } from "./add-product/add-product.component";
import { AuthorizationComponent } from './authorization/authorization.component';
import { AuthInterceptor } from "./services/auth.interceptor";
import { JwtHelper } from "angular2-jwt";
import {  map } from "rxjs/operators";
import { HttpInterceptorService, httpInterceptorFactory } from './services/http-interceptor.service';

export class ConfigmaxTranslateCompiler implements TranslateCompiler{
  compile(value: string, lang: string): string | Function {
    throw new Error('Method not implemented.');
  }
  compileTranslations(translations: any, lang: string) {
    return translations[0];
  }
}

export class ConfigmaxTranslateLoader implements TranslateLoader{
  constructor(private http: HttpClient){}
  getTranslation(lang: string): Observable<any> {
    const localePath: string = "./assets/i18n/messages_"+lang+".json";
    //return this.http.get(environment.localizationFilesPath+lang);
    return this.http.get(localePath).pipe(
      map((translations: any) => { 
          return translations.messages;
      }));
  }
  
  
}
export class ConfigmaxMissingTranslationHandler implements MissingTranslationHandler {
  constructor() {}
  missingTranslations={
    "admin.addProduct" : "Add Product",
    "admin.addProdAdmin" : "Add Product Admin",
    "admin.addUser" : "Add User",
    "admin.addRole" : "Add Role",
    "addProd.ProductName": "Product Name",
    "addProd.description": "Description",
    "addProd.status": "Status",
    "addProd.productId": "Product Id",
    "addProd.tooltip": "Product Ids fetched from DataBase",
    "addProd.updatedBy": "Updated By",
    "addProd.lastUpdated": "Last Updated",
    "addProd.prodActive": "Product is Active",
    "addProd.ProdDeactive": "Product is Deactivated",
    "paginationUsers": "users",
    "addProd.rmId": "Release Master Id",
    "addProd.submit": "Submit",
    "addProd.reset":"Reset",
    "addProd.vmwareAlertError": "Successfully added the product",
    "publishConfigMaxMsg": "Publish Configuration Maximums",
    "countMaximumMsg": "Do you want to publish current page Configuration Maximums ",
    "outOf": " out of",
    "configMaxMsg": "categories?",
    "publishAllMsg": "Do you want publish all configurations maximums?",
    "publish": "PUBLISH",
    "publishByPage": "PUBLISH BY PAGE",
    "publishAll": "PUBLISH ALL",
    "confirm": "Confirm",
    "subNav.review": "Review",
    "admin.authType": "Authorization Type",
    "admin.authRoleName": "Role Name",
    "admin.authNameMsg": "Role Name is recommended to be in the format of <ProductName>_Admin",
    "admin.authRoleDesc": "Description"
  }
  handle(params: MissingTranslationHandlerParams): string {
      if(params && params.key && this.missingTranslations[params.key]){
        return this.missingTranslations[params.key]
      }
      else{
        return params.key
      }
  }
}
@NgModule({
    declarations: [
        AppComponent,
        ReportsComponent,
        HomeComponent,
        LoginComponent,
        LimitsComponent,
        FooterComponent,
        AdminComponent,
        AuthComponent,
        CompareComponent,
        ReviewComponent,
        ModalComponent,
        ChatModalComponent,
        FormModalComponent,
        AlertComponent,
        AuthUsersComponent,
        ManageReleasesComponent,
        LimitFormModalComponent,
        GuestComponent,
        LimitlabelmodalComponent,
        CategoryModalComponent,
        ManageReleaseModalComponent,
        AddProductComponent,
        AuthorizationComponent,
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        ClarityModule,
        ROUTING,
        REPORTSROUTING,
        ADMINROUTING,
        REVIEWROUTING,
        COMPAREROUTING,
        NgxPaginationModule,
        HttpClientModule,
        AuthModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild({
          loader: {
            provide: TranslateLoader,
            deps: [HttpClient],
            useClass: ConfigmaxTranslateLoader
          },
          missingTranslationHandler:{
            provide: MissingTranslationHandler,
            useClass: ConfigmaxMissingTranslationHandler
          },
          useDefaultLang: true,
          isolate: true
      })
    ],
    providers: [
        AuthInterceptor,
        AuthGuard,
        Globals,
        AlertService,
        AuthenticationService,
        ReportsService,
        LimitsService,
        AuthService,
        Logger,
        Options,
        CookieService,
        SsoRedirectService,
        PDFGenerator,
        AdminService,
        CookieService,
        NumberConstants,
        EnvironmentsService,
        ApiService,
        AuthProviderService,
        TranslateService,
        TranslateStore,
        UserService,
        JwtHelper,
        {
          provide: Http,
          useFactory: httpInterceptorFactory,
          deps: [XHRBackend, RequestOptions]
        },
        [{ provide: LOCALE_ID, useValue: 'en-US' }]
    ],
    bootstrap: [AppComponent],
    schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts